import Collection from '@models/collection/collection.model';
import Financeur from '@models/financeurs/financeur/financeur.model';

export default class CFinanceurs extends Collection<Financeur> {
}
